import React, { useEffect } from "react"
import { useTrack } from "@hackler/react-sdk"

export default function NotFound() {
  const track = useTrack()
  useEffect(() => {
    track({ key: "homepage_error", properties: { errorCode: 404 } })
    window.location.replace("/")
  }, [])

  return <div />
}
